import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'auth-unlockaccount',
    templateUrl: './unlockaccount.component.html'
})
export class UnlockAccountComponent extends BaseComponent implements OnInit {
    accountUnlocked: boolean = false;

    constructor(private route: ActivatedRoute,
        private authService: AuthService,
        private router: Router) {
        super(route);
        this.emitDisplayLoadingDialog(true);
    }

    ngOnInit(): void {

      this.route.queryParams.subscribe(
        params => {
          let token = params['token'];
          this.unlockAccount(token);
        },
        error => {
          this.router.navigateByUrl('/');
        }
      );

    }

    unlockAccount(token: string) {
        this.authService.unlockAccount(token)
            .subscribe(returnValue => {
                if (returnValue) {
                    this.emitDisplayLoadingDialog(false);
                    this.accountUnlocked = true;
                }
                else {
                    this.router.navigateByUrl('/');
                }
            },
                error => {
                    this.emitDisplayLoadingDialog(false);
                    this.router.navigateByUrl('/');
                }
            );
    }

}
